import { notification } from "antd";
import {
  FETCH_RESPONSES_REQUEST,
  FETCH_RESPONSES_SUCCESS,
  FETCH_RESPONSES_FAILURE,
} from "../Types";
import { apiGet } from "../../services/apiInterceptor";

export const listReponses = (formId) => {
  return async (dispatch) => {
    dispatch({ type: FETCH_RESPONSES_REQUEST });

    try {
      // ✅ MIGRATION : Plus besoin de gérer manuellement le token et les headers
      const response = await apiGet(`api/responses/${formId}/responses`);

      const data = await response.json();

      if (!response.ok) {
        throw new Error(
          data?.message || "Erreur lors de la récupération des réponses"
        );
      }

      dispatch({
        type: FETCH_RESPONSES_SUCCESS,
        payload: data,
      });

      return data;
    } catch (error) {
      dispatch({ type: FETCH_RESPONSES_FAILURE, payload: error?.message });

      notification.error({
        message: error?.message || "Échec de la récupération des réponses",
        duration: 5,
      });
    }
  };
};
